var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlatformTelegramColorNegative(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 13c0 7.18-5.82 13-13 13S0 20.18 0 13 5.82 0 13 0s13 5.82 13 13zM13.466 9.597c-1.265.526-3.792 1.615-7.581 3.266-.616.244-.938.484-.968.718-.05.396.446.551 1.12.764.093.028.188.058.285.09.664.216 1.557.468 2.021.478.421.01.891-.164 1.41-.52 3.54-2.39 5.369-3.599 5.483-3.625.081-.018.193-.041.27.026.076.068.068.196.06.23-.05.21-1.994 2.017-3 2.953-.314.292-.537.498-.582.546-.102.106-.206.206-.306.302-.616.594-1.079 1.04.026 1.768.53.35.956.64 1.38.928.462.315.924.63 1.521 1.021.152.1.298.203.44.304.538.384 1.022.73 1.62.674.347-.032.706-.358.888-1.333.43-2.302 1.277-7.29 1.473-9.346a2.29 2.29 0 0 0-.022-.512.548.548 0 0 0-.185-.352c-.156-.126-.396-.153-.504-.151-.489.009-1.239.27-4.85 1.771z",
    fill: "#ededf1",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatformTelegramColorNegative);
export default __webpack_public_path__ + "static/media/platform-telegram-color-negative.1916272542d5f9ceaec2fcafa6eae3f2.svg";
export { ForwardRef as ReactComponent };